<template>
<div class="card"  v-if="user.fullName != null">
      <img :src="user.avatar" :alt="user.fullName" v-if="user.avatar" style="width:50%">
  <h1>{{user.fullName}}</h1>
  <p class="title"> {{user.status}}</p>
   <p><v-icon color="indigo">{{'chat._email_'|translate}}</v-icon> {{user.email}}</p>
  <p><v-icon color="indigo">{{'chat._phone_'|translate}}</v-icon> {{user.phone_number}}</p>
    <p>{{user.phone_number}}<p>
  <div style="margin: 24px 0;">
    <a href="#"><i class="fa fa-dribbble"></i></a> 
    <a href="#"><i class="fa fa-twitter"></i></a>  
    <a href="#"><i class="fa fa-linkedin"></i></a>  
    <a href="#"><i class="fa fa-facebook"></i></a> 
  </div>
  <p><button @click="check_conversation(user.uuid)" >{{'chat._chat_btn_'|translate}}</button></p>
</div>
</template>

<script>
//import { getUserById } from "@/api/user";
import { db } from '@/api/firebaseInit';
import firebase from 'firebase';
export default {
  data() {
    return {
      conversation_id:'',
      createdById:'',
       createdBy:'',
       participants:[],
       participants_search:[],
      chat: null,
      selectedTab: null,
      Users: []
    };
  },
  mounted() {
  //  this.fetchUsers();
  },
   created() {
    //  this.fetchUsers();
          if(firebase.auth().currentUser) {
        this.createdById = firebase.auth().currentUser.uid
        this.createdBy = firebase.auth().currentUser.displayName
        if(!this.createdBy) {
          this.createdBy = firebase.auth().currentUser.email
        }
      }
  },
  computed: {
    /*     user() {
      let user = this.$store.getters.getUserById(this.$route.params.uuid);
      return Object.assign(Origin, user);
    },
 */
    user() {
      // this.fetchUsers();
      let Origin = {
        name: "Chat",
        avatar: ""
      };
      let user = this.$store.getters.getUserById(this.$route.params.uuid);
      return Object.assign(Origin, user);
   
    }
  },
  methods: {

    check_conversation (uuid) {
      var fname='';
      var lname='';
          this.participants=[];
        this.participants_search=[];
    var user_existe= false;
    var new_conversation= true;
    var conversation_id_exist = ''
      this.participants_search.push(this.createdById)
       this.participants_search.push(uuid)
      let convos = this.$store.getters.convos;
    

      for( var i =0;i<this.participants_search.length;i++) {
       
        let user = this.$store.getters.getUserById(this.participants_search[i]);
        console.log("SELECTED ",this.participants_search[i])
        if(user.first_name == null) {
           fname = ''
        } else {
          fname = user.first_name
        }
             if(user.last_name == null) {
           lname = ''
        } else {
          lname = user.last_name
        }
        var user_obj ={first_name:fname,last_name:lname,thumbnail_url:user.thumbnail_url,user_id:user.uuid}
        this.participants.push(user_obj)
      }
    

      for(var j=0;j<convos.length;j++){
        for(var p =0;p<convos[j].participants.length;p++){

          if (convos[j].participants[p].user_id == uuid ) {
            
            if (convos[j].participants.length == this.participants.length) { 
              new_conversation= false;
              conversation_id_exist =convos[j].uuid
              break;
            }
          }
        }
        if(!new_conversation){
          break;
        }
      }

        if(new_conversation) {
         this.create_conversation(this.participants)
        } 
         else {
        this.$router.push({name: 'ChatMessaging', params: {uuid: conversation_id_exist}});

        }

    },

    create_conversation(participants) {

      const convosRef = db.collection("conversations").doc();
      const refKey = convosRef.id;
      this.conversation_id = refKey;
      
      convosRef
        .set({
          created_date: new Date(),
          entityKey: this.conversation_id,
          id: this.conversation_id,
          image_url:"default",
          last_message:"&nbsp",
          last_update:new Date(),
          participants:participants,
          title:"&nbsp",
          type:"single"
        })
        .then(() => {

              this.$store.dispatch('fetchConvos').then(() => {
      this.$store.dispatch('fetchMessages').then(() => {
         this.$router.push({name: 'ChatMessaging', 
        params: {uuid:  this.conversation_id,  new_convos:'true'}});  
      })
    })       
        })
        .catch(error => {
          console.error("Error adding conversation: ", error);
        });


    },
/* 
    getUserById(entityKey) {
      for (var i = 0; i < this.Users.length; i++) {
        if (this.Users[i].uuid == entityKey || this.Users.id == entityKey) {
          return this.Users[i];
        }
      }
    }, */
    fetchUsers: function(context) {
      return new Promise((resolve, reject) => {
        const Users = [];
        db.collection("Users")
          .get()
          .then(querySnapshot => {
            querySnapshot.forEach(doc => {
              const data = {
                uuid: doc.id,
                id: doc.data().id,
                entityKey: doc.data().entityKey,
                image_url: doc.data().image_url,
                first_name: doc.data().first_name,
                last_name: doc.data().last_name,
                census_id: doc.data().census_id,
                status: doc.data().status,
                phone: doc.data().phone_number,
                online: doc.data().online,
                email: doc.data().email,
                status: doc.data().status,
                thumbnail_url: doc.data().thumbnail_url,
                fullName: doc.data().first_name + " " + doc.data().last_name,
                name: doc.data().first_name + " " + doc.data().last_name,
                avatar: {
                  src: "/static/avatar/avatar.png",
                  size: 72
                }
              };
              if (data.image_url === "default") {
                data.image_url = "/static/avatar/avatar.png";
              }
              data.avatar = data.image_url;
              this.Users.push(data);
            });
          });
     
      });
    },

    contactRoute(id) {
      return "/chat/contact/" + id;
    },
    firstLetter(name) {
      return name.charAt(0);
    },
    userStatusColor(item) {
      return item.online ? "green" : "grey";
    }
  }
};
</script>


<style lang='scss' scoped>


.card {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  max-width: 300px;
  margin: auto;
  text-align: center;
  font-family: arial;
}

.title {
  color: grey;
  font-size: 18px;
}

button {
  border: none;
  outline: 0;
  display: inline-block;
  padding: 8px;
  color: white;
  background-color: #000;
  text-align: center;
  cursor: pointer;
  width: 100%;
  font-size: 18px;
}

a {
  text-decoration: none;
  font-size: 22px;
  color: black;
}

button:hover, a:hover {
  opacity: 0.7;
}

</style>




// WEBPACK FOOTER //
// src/components/chat/ChatContactProfile.vue